import { render, staticRenderFns } from "./SuccessSection.vue?vue&type=template&id=9b230066&"
import script from "./SuccessSection.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SuccessSection.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports